import {
  CheckboxField,
  NewResourceForm,
  ObjectField,
  TextField,
  WorkflowSelect,
} from "~/components/Form";
import { useCreateGroup } from "~/domain/datastores";
import { makeGroupLocation } from "~/paths";
import { createGroupSchema } from "../schemas";

export function GroupCreateForm() {
  return (
    <NewResourceForm
      schema={createGroupSchema}
      defaultValues={{
        name: null,
        defaultWorkflowId: null,
        locked: false,
        note: null,
        context: null,
      }}
      resourceName="group"
      mutation={useCreateGroup()}
      generateLocation={(response) =>
        makeGroupLocation({ groupId: response.data.id })
      }
    >
      {(control) => (
        <>
          <TextField control={control} name="name" required />
          <WorkflowSelect control={control} name="defaultWorkflowId" />
          <CheckboxField control={control} name="locked" />
          <TextField control={control} name="note" multiline />
          <ObjectField control={control} name="context" />
        </>
      )}
    </NewResourceForm>
  );
}
